export enum ApiTagsEnum {
  GET_ALL_CONTESTS = 'GET_ALL_CONTESTS',
  GET_ONE_CONTEST = 'GET_ONE_CONTEST',
  GET_LIVE_CONTEST = 'GET_LIVE_CONTEST',
  GET_WEEKLY_STATS = 'GET_WEEKLY_STATS',
  GET_CONTEST_LEADERBOARD = 'GET_CONTEST_LEADERBOARD',
}
